export default "__VITE_ASSET__CPudVDSq__"